import React, { Component, createRef } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import { 
  ChevronIcon2,
  WhatsAppIcon,
  TelegramIcon
} from './SVGIcons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import Social from './Social'
import OffcanvasForm from './OffcanvasForm';

// Импорт стилей Swiper
import 'swiper/css';
import 'swiper/css/navigation';

class App extends Component {
  constructor(props) {
    super(props);
    this.catalogSwiperRef = createRef();
    this.state = {
      isCatalogBeginning: true,
      isCatalogEnd: false,
      showForm: false // состояние для формы
    };
  }

  handleCatalogSlideChange = (swiper) => {
    this.setState({
      isCatalogBeginning: swiper.isBeginning,
      isCatalogEnd: swiper.isEnd
    });
  }

  // Методы для открытия/закрытия формы
  openForm = () => {
    this.setState({ showForm: true });
  };

  closeForm = () => {
    this.setState({ showForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  // Функция для получения иконки по номеру
  getIconByNumber = (iconNumber) => {
    // ... (функция остается без изменений)
  };

  render() {
    const data = this.props?.data || {};
    const katalog = data?.pkatalog || [];
    const { isCatalogBeginning, isCatalogEnd, showForm } = this.state;
    const products = data?.products || [];
    const dlCards = data?.dl_cards || [];
    const { showWindow } = this.props;

    return (
      <>
        <div className='mt-[95px] xl:mt-[150px] leading-none'>
          <div className='container'>
            <div className='inline-flex items-center px-[15px] h-auto xl:h-[38px] py-[10px] xl:py-0 bg-[#F5F7F9] rounded-full gap-[5px] text-[14px]'>
              <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 6.1875V13.5C15 15.75 13.6575 16.5 12 16.5H6C4.3425 16.5 3 15.75 3 13.5V6.1875C3 3.75 4.3425 3.1875 6 3.1875C6 3.6525 6.18748 4.0725 6.49498 4.38C6.80248 4.6875 7.2225 4.875 7.6875 4.875H10.3125C11.2425 4.875 12 4.1175 12 3.1875C13.6575 3.1875 15 3.75 15 6.1875Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 3.1875C12 4.1175 11.2425 4.875 10.3125 4.875H7.6875C7.2225 4.875 6.80248 4.6875 6.49498 4.38C6.18748 4.0725 6 3.6525 6 3.1875C6 2.2575 6.7575 1.5 7.6875 1.5H10.3125C10.7775 1.5 11.1975 1.6875 11.505 1.995C11.8125 2.3025 12 2.7225 12 3.1875Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 9.75H9" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 12.75H12" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] flex flex-wrap items-center gap-[9px] text-[#032432]'>
                <a href={data?.katalog_link} className='text-[#032432]/60'>Каталог</a>
                <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.433594 0.249512L3.60283 5.74951L0.433594 11.2495" stroke="#032432" strokeOpacity="0.6"/>
                </svg>
                <div>{data?.pagetitle}</div>
              </div>
            </div>

            <h1 className='font-medium mt-[30px] xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start'>{Parser(data?.full_title || data?.pagetitle)}</h1>

            {/* Слайдер для каталога */}
            <div className='mt-[20px] relative catalog-slider-container hidden xl:block'>
              {/* Левая стрелка */}
              <button 
                className={`absolute left-[-20px] top-1/2 -translate-y-1/2 z-10 w-[38px] h-[38px] rounded-full bg-[#032432] flex items-center justify-center transition-opacity duration-300 ${
                  isCatalogBeginning ? 'opacity-0' : 'opacity-100 hover:bg-opacity-80 cursor-pointer'
                }`}
                onClick={() => !isCatalogBeginning && this.catalogSwiperRef.current?.slidePrev()}
                disabled={isCatalogBeginning}
              >
                <svg width="8" height="14" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rotate-180">
                  <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white" strokeWidth="1.5"/>
                </svg>
              </button>

              {/* Правая стрелка */}
              <button 
                className={`absolute right-[-20px] top-1/2 -translate-y-1/2 z-10 w-[38px] h-[38px] rounded-full bg-[#032432] flex items-center justify-center transition-opacity duration-300 ${
                  isCatalogEnd ? 'opacity-0' : 'opacity-100 hover:bg-opacity-80 cursor-pointer'
                }`}
                onClick={() => !isCatalogEnd && this.catalogSwiperRef.current?.slideNext()}
                disabled={isCatalogEnd}
              >
                <svg width="8" height="14" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white" strokeWidth="1.5"/>
                </svg>
              </button>

              <Swiper
                onSwiper={(swiper) => {
                  this.catalogSwiperRef.current = swiper;
                  this.handleCatalogSlideChange(swiper);
                }}
                onSlideChange={this.handleCatalogSlideChange}
                modules={[Navigation]}
                spaceBetween={10}
                slidesPerView={5}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 10
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 10
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 10
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 10
                  },
                  1280: {
                    slidesPerView: 5,
                    spaceBetween: 10
                  }
                }}
                className='catalog-slider'
              >
                {katalog.map((elm, index) => (
                  <SwiperSlide key={index}>
                    <a 
                      href={elm.url}
                      className='block bg-[#F5F7F9] rounded-[15px] p-[20px] bg-no-repeat bg-right-bottom min-h-[145px] h-full'
                      style={elm.image != '' ? {
                        backgroundImage: `url(${elm.image})`
                      } : {}}
                    >
                      <div className='flex items-center justify-center bg-white rounded-full w-[35px] h-[35px]'>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.62295 5.37095C9.4787 5.00608 9.36839 4.66667 9.29202 4.35272C9.20717 4.03028 9.15201 3.73753 9.12656 3.47449L1.88437 10.7167L1.19706 10.0294L8.43925 2.78718C8.16772 2.75324 7.87498 2.69809 7.56102 2.62172C7.23858 2.53687 6.89917 2.42656 6.54279 2.29079L7.141 1.69258C8.295 1.77743 9.31748 1.67137 10.2084 1.37438L10.5394 1.70531C10.2339 2.58778 10.1278 3.61025 10.2212 4.77274L9.62295 5.37095Z" fill="black"/>
                        </svg>
                      </div>
                      <div className='mt-[14px] text-[18px] text-[#032432]'>
                        {elm?.str1}
                        {elm?.str2 != '' &&
                          <>
                            <br /><span className='text-[#032432]/60'>{elm?.str2}</span>
                          </>
                        }
                      </div>
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className='xl:hidden flex items-center w-[calc(100%)+10px] overflow-x-auto overflow-y-hidden mt-[30px] pb-[10px] gap-[10px]'>
              {katalog.map((elm, index) => (
                <a 
                  key={index}
                  href={elm.url}
                  className='block bg-[#F5F7F9] rounded-[15px] p-[20px] bg-no-repeat bg-right-bottom w-[228px] min-h-[132px] flex-none'
                  style={elm.image != '' ? {
                    backgroundImage: `url(${elm.image})`
                  } : {}}
                >
                  <div className='flex items-center justify-center bg-white rounded-full w-[35px] h-[35px]'>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.62295 5.37095C9.4787 5.00608 9.36839 4.66667 9.29202 4.35272C9.20717 4.03028 9.15201 3.73753 9.12656 3.47449L1.88437 10.7167L1.19706 10.0294L8.43925 2.78718C8.16772 2.75324 7.87498 2.69809 7.56102 2.62172C7.23858 2.53687 6.89917 2.42656 6.54279 2.29079L7.141 1.69258C8.295 1.77743 9.31748 1.67137 10.2084 1.37438L10.5394 1.70531C10.2339 2.58778 10.1278 3.61025 10.2212 4.77274L9.62295 5.37095Z" fill="black"/>
                    </svg>
                  </div>
                  <div className='mt-[14px] text-[16px] text-[#032432]'>
                    {elm?.str1}
                    {elm?.str2 != '' &&
                      <>
                        <br /><span className='text-[#032432]/60'>{elm?.str2}</span>
                      </>
                    }
                  </div>
                </a>
              ))}
            </div>

            <div className='grid grid-cols-2 xl:grid-cols-5 gap-[11px] xl:gap-[19px] mt-[30px] xl:mt-[60px]'>
              {products.map((elm, k) => (
                <a href={elm?.url} key={k} className="group leading-none tracking-[-0.04em]">
                  <div className='flex items-center justify-center overflow-hidden rounded-[15px] w-full h-[210px] xl:h-[271px] relative'>
                    <div className="absolute top-[15px] right-[15px] xl:top-[20px] xl:right-[20px] w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] rounded-full bg-[#F5F7F9] flex items-center justify-center text-black text-[18px] leading-none transition-all duration-300 cursor-pointer group-hover:bg-[#009EE3] group-hover:text-white">
                      <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.25209 4.35598C9.40809 3.99598 9.57009 3.67798 9.73809 3.40198C9.90609 3.11398 10.0741 2.86798 10.2421 2.66398H9.39667e-05V1.69198H10.2421C10.0741 1.47598 9.90609 1.22998 9.73809 0.953984C9.57009 0.665984 9.40809 0.347984 9.25209 -1.61529e-05H10.0981C10.8541 0.875984 11.6521 1.52398 12.4921 1.94398V2.41198C11.6521 2.81998 10.8541 3.46798 10.0981 4.35598H9.25209Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <img src={elm.img} alt={elm.name} width={137} height={192} className="object-contain w-full h-auto" />
                  </div>
                  <div className='mt-[14px] text-[16px] xl:text-[18px] text-[#032432] group-hover:text-[#009EE3] transition-colors'>
                    {elm.name}
                  </div>
                  <div className='mt-[10px] text-[14px] xl:text-[16px] text-[#032432]/60'>
                    {elm.text}
                  </div>
                </a>
              ))}
            </div>

            {data?.content != '' && (
              <div className='mt-[50px] text-black/60 text-[14px] xl:text-[16px] text-center xl:text-start page_content'>{Parser(data?.content || ``)}</div>
            )}

            <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
              <div className='container'>
                <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
                  <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M5.99922 2.25H6.74922C5.28672 6.63 5.28672 11.37 6.74922 15.75H5.99922" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M11.25 2.25C12.7125 6.63 12.7125 11.37 11.25 15.75" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2.25 12V11.25C6.63 12.7125 11.37 12.7125 15.75 11.25V12" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M2.25 6.74922C6.63 5.28672 11.37 5.28672 15.75 6.74922" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div className='tracking-[-0.04em] text-[#032432]/60'>Область применения</div>
                  </div>
                </div>
                <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(data?.dl_title_2)}</h2>
                <div className='mt-[10px] text-black/60 text-[14px] xl:text-[16px] text-center xl:text-start'>{Parser(data?.dl_text_2)}</div>
                
                {/* Динамические карточки из dl_cards */}
                <div className='grid mt-[20px] gap-[8px] grid-cols-1 xl:grid-cols-4'>
                  {dlCards.map((card, index) => (
                    <div 
                      key={index}
                      className='min-h-[180px] rounded-[15px] p-[20px]'
                      style={{
                        backgroundImage: `url("${card.image}")`,
                        backgroundSize: 'cover'
                      }}
                    >
                      {this.getIconByNumber(card.icon)}
                      <div className='mt-[61px] text-[16px] xl:text-[18px] text-white'>{card.name}</div>
                      <div className='mt-[10px] text-[14px] xl:text-[16px] text-white/60'>{card.text}</div>
                    </div>
                  ))}
                </div>

                <div className='bg-[#032432] rounded-[15px] p-[20px] mt-[20px] flex flex-col xl:flex-row justify-between items-center'
                  style={{
                    backgroundImage: `url("${data?.dl_cardbg}")`,
                    backgroundSize: 'cover'
                  }}
                >
                  <div>
                    <div className='text-[16px] xl:text-[18px] text-white'>Не смогли найти вашу отрасль?</div>
                    <div className='mt-[10px] text-[14px] xl:text-[16px] text-white/60'>Оставьте заявку или напишите нам, мы свяжемся с вами оперативно и обсудим возникшие вопросы</div>
                  </div>
                  <div className='flex w-full xl:w-auto items-center gap-[5px] mt-[20px] xl:mt-0'>
                    {/* Кнопка Оставить заявку */}
                    <div 
                      onClick={this.openForm}
                      className='flex flex-1 xl:flex-auto justify-center items-center gap-[9px] h-[50px] px-0 xl:px-[35px] bg-[#009EE3] text-white rounded-full cursor-pointer text-[14px] xl:text-[16px] hover:bg-[#0082c0] transition-colors duration-300'
                    >
                      <div>Оставить заявку</div>
                      <ChevronIcon2 stroke="white" />
                    </div>
                    <Social social={data?.social || []} width={50} />
                  </div>
                </div>
              </div>
            </div>

            <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
              <div className='container'>
                <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(data?.dl_title_3)}</h2>
                <div className='flex flex-col xl:flex-row items-start gap-[10px] mt-[30px]'>
                  <div className='w-full xl:w-[241px] xl:min-h-[196px] rounded-[15px] p-[20px] bg-[#032432]'
                    style={{
                      backgroundImage: `url("${data?.dl_cardbg2}")`,
                      backgroundSize: 'cover'
                    }}
                  >
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[23px] w-full'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 8.5V3" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 21V15.5" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 3H14" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 21H14" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8.97094 10.25L4.21094 7.5" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M19.7913 16.5L15.0312 13.75" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M3.21094 9.22952L5.21094 5.76953" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M18.7891 18.2295L20.7891 14.7695" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M15.5 12C15.5 12.64 15.33 13.23 15.03 13.75C14.42 14.8 13.29 15.5 12 15.5C10.71 15.5 9.58 14.8 8.97 13.75C8.67 13.23 8.5 12.64 8.5 12C8.5 11.36 8.67 10.77 8.97 10.25C9.58 9.2 10.71 8.5 12 8.5C13.29 8.5 14.42 9.2 15.03 10.25C15.33 10.77 15.5 11.36 15.5 12Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M19.7913 7.5L15.0312 10.25" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8.97094 13.75L4.21094 16.5" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M20.7891 9.22952L18.7891 5.76953" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M5.21094 18.2295L3.21094 14.7695" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <div className='text-[18px] text-white'>Работают при экстремальных температурах</div>
                    </div>
                    <div className='mt-[10px] text-white/60 text-[14px]'>Быстро разрушают наледь и снежные образования — до -60 °C.</div>
                  </div>
                  <div className='w-full xl:w-[288px] min-h-[196px] rounded-[15px]'>
                    <img src={data?.dl_cardbg3} alt='' className='w-full h-auto' />
                  </div>
                  <div className='w-full xl:w-[324px] xl:min-h-[196px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[41px] w-full'>
                      <div className='flex items-center gap-[5px]'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.9 22H7.10001C5.40001 22 4 20.61 4 18.9V5.10001C4 3.40001 5.39001 2 7.10001 2H16.9C18.6 2 20 3.39001 20 5.10001V18.9C20 20.61 18.61 22 16.9 22Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M18.5 13H5.5C4.67 13 4 12.33 4 11.5V9.5C4 8.67 4.67 8 5.5 8H18.5C19.33 8 20 8.67 20 9.5V11.5C20 12.33 19.33 13 18.5 13Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M8.49451 17.6992H8.50349" stroke="#009EE3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M15.4945 17.6992H15.5035" stroke="#009EE3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M9.5 5H14.5" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.4198 12.3697C21.2898 12.7197 21.8297 13.7497 21.6297 14.6597L21.2197 16.5197C20.5097 19.7197 17.9997 21.9997 14.3797 21.9997H9.61974C5.99974 21.9997 3.48974 19.7197 2.77974 16.5197L2.36974 14.6597C2.16974 13.7497 2.70973 12.7197 3.57973 12.3697L4.99974 11.7997L10.5098 9.58969C11.4698 9.20969 12.5297 9.20969 13.4897 9.58969L18.9997 11.7997L20.4198 12.3697Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M12 22V10" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M19 8V11.8L13.49 9.59C12.53 9.21 11.47 9.21 10.51 9.59L5 11.8V8C5 6.35 6.35 5 8 5H16C17.65 5 19 6.35 19 8Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14.5 5H9.5V3C9.5 2.45 9.95 2 10.5 2H13.5C14.05 2 14.5 2.45 14.5 3V5Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.02828 21.6898L11.3583 19.7298C11.7083 19.4298 12.2883 19.4298 12.6383 19.7298L14.9683 21.6898C15.5083 21.9598 16.1683 21.6898 16.3683 21.1098L16.8083 19.7798C16.9183 19.4598 16.8083 18.9898 16.5683 18.7498L14.2983 16.4698C14.1283 16.3098 13.9983 15.9898 13.9983 15.7598V12.9098C13.9983 12.4898 14.3083 12.2898 14.6983 12.4498L19.6083 14.5698C20.3783 14.8998 21.0083 14.4898 21.0083 13.6498V12.3598C21.0083 11.6898 20.5083 10.9198 19.8883 10.6598L14.2983 8.24977C14.1383 8.17977 13.9983 7.96977 13.9983 7.78977V4.78977C13.9983 3.84977 13.3083 2.73977 12.4683 2.30977C12.1683 2.15977 11.8183 2.15977 11.5183 2.30977C10.6783 2.73977 9.98828 3.85977 9.98828 4.79977V7.79977C9.98828 7.97977 9.84828 8.18977 9.68828 8.25977L4.10828 10.6698C3.48828 10.9198 2.98828 11.6898 2.98828 12.3598V13.6498C2.98828 14.4898 3.61828 14.8998 4.38828 14.5698L9.29828 12.4498C9.67828 12.2798 9.99828 12.4898 9.99828 12.9098V15.7598C9.99828 15.9898 9.86828 16.3098 9.70828 16.4698L7.43828 18.7498C7.19828 18.9898 7.08828 19.4498 7.19828 19.7798L7.63828 21.1098C7.81828 21.6898 8.47828 21.9698 9.02828 21.6898Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <div className='text-[18px] text-[#032432]'>Универсальны по применению</div>
                    </div>
                    <div className='text-black/60 mt-[10px] text-[14px]'>Подходят для авиации, ЖД, энергетики, инфраструктуры и транспорта. Эффективны на ВПП, стрелках, палубах.</div>
                  </div>
                  <div className='flex-1 xl:min-h-[196px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[41px] w-full'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.15882 22C3.97882 22 3.13882 19.47 4.49882 16.39L8.74882 6.74H8.44882C7.79882 6.74 7.19882 6.48 6.76882 6.05C6.32882 5.62 6.06882 5.02 6.06882 4.37C6.06882 3.07 7.12882 2 8.43882 2H15.5488C16.2088 2 16.7988 2.27 17.2288 2.7C17.7888 3.26 18.0688 4.08 17.8588 4.95C17.5888 6.03 16.5488 6.74 15.4388 6.74H15.2788L19.4988 16.4C20.8488 19.48 19.9688 22 15.8288 22H8.15882Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M5.9375 13.1194C5.9375 13.1194 8.9975 12.9994 11.9975 13.9994C14.9975 14.9994 17.8275 13.1094 17.8275 13.1094" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <div className='text-[18px] text-[#032432]'>Безопасный состав</div>
                    </div>
                    <div className='text-black/60 mt-[10px] text-[14px]'>Экологически сбалансированные формулы. Не вредят металлам, покрытиям и окружающей среде.</div>
                  </div>
                </div>
                <div className='flex flex-col xl:flex-row items-start gap-[10px] mt-[10px]'>
                  <div className='w-full xl:w-[241px] xl:min-h-[181px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[26px] w-full'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.48047 18.3505L10.5805 20.7505C10.9805 21.1505 11.8805 21.3505 12.4805 21.3505H16.2805C17.4805 21.3505 18.7805 20.4505 19.0805 19.2505L21.4805 11.9505C21.9805 10.5505 21.0805 9.35046 19.5805 9.35046H15.5805C14.9805 9.35046 14.4805 8.85046 14.5805 8.15046L15.0805 4.95046C15.2805 4.05046 14.6805 3.05046 13.7805 2.75046C12.9805 2.45046 11.9805 2.85046 11.5805 3.45046L7.48047 9.55046" stroke="#009EE3" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
                        <path d="M2.38281 18.3504V8.55039C2.38281 7.15039 2.98281 6.65039 4.38281 6.65039H5.38281C6.78281 6.65039 7.38281 7.15039 7.38281 8.55039V18.3504C7.38281 19.7504 6.78281 20.2504 5.38281 20.2504H4.38281C2.98281 20.2504 2.38281 19.7504 2.38281 18.3504Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <div className='text-[18px] text-[#032432]'>Надёжная защита и снижение затрат</div>
                    </div>
                    <div className='text-black/60 mt-[10px] text-[14px]'>Предотвращают образование наледи, продлевают срок службы техники.</div>
                  </div>
                  <div className='w-full xl:w-[288px] xl:min-h-[181px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[26px] w-full'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.17188 7.43945L12.0019 12.5494L20.7719 7.46942" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 21.6091V12.5391" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.9306 2.48L4.59061 5.45003C3.38061 6.12003 2.39062 7.80001 2.39062 9.18001V14.83C2.39062 16.21 3.38061 17.89 4.59061 18.56L9.9306 21.53C11.0706 22.16 12.9406 22.16 14.0806 21.53L19.4206 18.56C20.6306 17.89 21.6206 16.21 21.6206 14.83V9.18001C21.6206 7.80001 20.6306 6.12003 19.4206 5.45003L14.0806 2.48C12.9306 1.84 11.0706 1.84 9.9306 2.48Z" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16.9978 13.2396V9.57965L7.50781 4.09961" stroke="#009EE3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <div className='text-[18px] text-[#032432]'>Инвестиция в эффективность</div>
                    </div>
                    <div className='text-black/60 mt-[10px] text-[14px]'>Выбирая нас, вы получаете гарантированный результат, лучшую продукцию и надежного поставщика.</div>
                  </div>
                  <div className='flex-1 min-h-[181px] rounded-[15px] p-[20px] bg-[#009EE3]'
                    style={{
                      backgroundImage: `url("${data?.dl_cardbg4}")`,
                      backgroundSize: 'cover'
                    }}
                  >
                    <div className='flex justify-between items-start'>
                      <h3 className='font-medium text-[24px] xl:text-[36px] text-white'>Готовы к поставке<br />продукции <span className='text-white/60'>— уже сегодня</span></h3>
                      <img className='hidden xl:block' src={data?.slogo} width={50} height={50} alt='logo' />
                    </div>
                    <div className='flex justify-between flex-col xl:flex-row items-start xl:items-center mt-[10px] gap-[20px] xl:gap-[26px]'>
                      <div className='text-white/60 text-[14px] xl:text-[16px]'>Оставьте заявку, и мы подготовим для вас персональное коммерческое предложение. Предлагаем стабильные поставки от 1 тонны с чёткими сроками и полным пакетом документов.</div>
                      <div className='w-full xl:w-auto flex justify-between gap-[10px]'>
                        {/* Кнопка Связаться (открывает модальное окно) */}
                        <div onClick={() => showWindow()} className='flex flex-1 items-center justify-center gap-[9px] h-[38px] xl:h-[50px] px-[19px] bg-white text-black rounded-full cursor-pointer hover:bg-gray-100 transition-colors duration-300'>
                          <div className='text-[14px] xl:text-[16px]'>Связаться</div>
                          <ChevronIcon2 stroke="black" />
                        </div>
                        <img src={data?.slogo} alt='slogo' width={38} height={38} className='xl:hidden flex-none' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Форма обратной связи */}
        <OffcanvasForm
          show={showForm}
          hide={this.closeForm}
          formTitle="Оставить заявку"
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;